<template>
  <FrequentlyAsk />
</template>

<script>
import FrequentlyAsk from "@/components/FrequentlyAsk.vue";

export default {
  components: {
    FrequentlyAsk
  },
  data() {
    return {
      publicPath: process.env.BASE_URL
    };
  }
};
</script>